import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Configurator',
    component: () => import('@/components/configurator/ConfiguratorViewer.vue'),
    meta: { 
      title: 'Configurateur Suzuki e VITARA',
      image: '/public/versions/e_vitara_avantage_privilege_thumbnail.png'
    }
  },
  {
    path: '/interior',
    name: 'Interior',
    component: () => import('@/views/InteriorView.vue'),
    meta: { title: 'Vue intérieure 360°' }
  },
  {
    path: '/summary',
    name: 'Summary',
    component: () => import('@/components/configurator/ConfigSummary.vue'),
    meta: { title: 'Récapitulatif configuration' }
  },
  {
    path: '/grade/:id',
    name: 'Grade',
    component: () => import('@/views/GradeView.vue'),
    props: true,
    meta: { title: 'Grade sélectionné' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

export default routes;